import React, { useState } from "react";
import axios from "axios";
import SubmitProposal from "./SubmitProposal";

const LandAcquistion = ({ beneficiaryDetails }) => {
  debugger
  // const [beneficiaryDetails, setBeneficiaryDetails] = useState([]);
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [currentStep, setCurrentStep] = useState(0)
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [landaccdata, setLandAccData] = useState({
    LandConsentType: "Pradhan Consent",
  });

  const handleSave = async () => {
    debugger;
    setLoading(true);
    setError(null);

    try {
      debugger;
      const updatedLandAccData = {
        ...landaccdata,
        // Update the specific value you need, e.g., LandConsentType
        LandConsentType: "Pradhan Consent",
      };
      // Call the API to update the compensation details
      const response = await axios.put(
        "https://backurrda.sarmar.co.in/api/BeneficiaryUpdate/updateLandAccquisitonConsnet",
        {
          beneficiaries: beneficiaryDetails, // Send the updated beneficiary data
          landAccData: updatedLandAccData,
        }
      );

      if (response.status === 200) {
        alert("Land Consent updated successfully!");
        setLandAccData(updatedLandAccData);
        setLoading(false);
      }
    } catch (error) {
      setError("Failed to update Land Consent.");
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 px-6 py-4 overflow-auto">
      <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
        <h1>Land Acquisition Consent</h1>
      </div>
      <section className="mt-10">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">Beneficiaries</th>
              <th className="border border-gray-300 p-2">Consent Type</th>
              <th className="border border-gray-300 p-2">
                Power of Attorney To
              </th>
              <th className="border border-gray-300 p-2 w-96">
                Upload Consent Document
              </th>
            </tr>
          </thead>
          <tbody>
            {beneficiaryDetails.map((beneficiary, index) => (
              <tr key={beneficiary.CompensationId}>
                <td className="border border-gray-300 p-2">
                  <input
                    className="w-full"
                    type="text"
                    value={beneficiary.Name}
                    // onChange={(e) => {
                    //   setLandAccData({
                    //     ...landaccdata, BenefiaciaryId : e.target.value
                    //   })
                    // }}
                    readOnly
                  />
                </td>
                <td className="border border-gray-300 p-2">
                  <select
                    className="border rounded-md p-2 w-full"
                    // name="Pradhan Consent"
                    name={`BeneficiaryId-${beneficiary.BeneficiaryId}`} // Unique name for each dropdown
                    value={beneficiary.LandConsentType || "Pradhan Consent"} // Set default value if available
                    onChange={(e) => {
                      // Update LandConsentType when selection changes
                      const updatedBeneficiaries = [...beneficiaryDetails];
                      updatedBeneficiaries[index].LandConsentType =
                        e.target.value;

                      // Update the beneficiaryDetails state with the modified object
                      setBeneficiaries(updatedBeneficiaries);
                    }}
                  >
                    <option value="Pradhan Consent">Pradhan Consent</option>
                  </select>
                </td>
                <td className="border border-gray-300 p-2">
                  <select
                    className="border rounded-md p-2 w-full"
                    name="Select Beneficiary"
                  >
                    <option disabled value="Select Beneficiary">
                      Select Beneficiary
                    </option>
                  </select>
                </td>
                <td className="border border-gray-300 p-2 flex gap-2 w-96">
                  <div class="ml-1 items-center justify-center grid grid-cols-2">
                    <label
                      for="dropzone-file"
                      class="mr-2 flex flex-col items-center justify-center w-max h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-white dark:hover:border-gray-500 dark:hover:bg-gray-200"
                    >
                      <div class="flex items-center justify-end pt-5 pb-6">
                        <p class="text-md text-gray-500 dark:text-white mr-2">
                          📄 Power of Attorney
                        </p>
                        <svg
                          class="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 20 16"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                          />
                        </svg>
                      </div>
                      <input
                        disabled
                        id="dropzone-file"
                        type="file"
                        class="hidden"
                      />
                    </label>
                  </div>
                  <div class="flex items-center justify-center w-80">
                    <label
                      for="dropzone-file"
                      class="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
                    >
                      <div class="flex items-center justify-end pt-5 pb-6">
                        <p class="text-md text-gray-500 dark:text-gray-400 mr-2">
                          📄 Affidavit
                        </p>
                        <svg
                          class="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 20 16"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                          />
                        </svg>
                      </div>
                      <input
                        disabled
                        id="dropzone-file"
                        type="file"
                        class="hidden"
                      />
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <hr className="mt-2" />
      <div className="flex mt-10">
        <input type="radio" />
        <label htmlFor="" className="mt-2 ml-2">
          Patwari Report on behalf of all Beneficiary
        </label>

        <div class=" flex ml:max ml-[450px] items-end justify-center w-80">
          <label
            for="dropzone-file"
            class="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-200"
          >
            <div class="flex items-center justify-end pt-5 pb-6">
              <p class="text-md text-gray-500 dark:text-gray-400 mr-2">
                📄 Patwari Report
              </p>
              <svg
                class="w-4 h-4 mb- text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              {/* <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span> or drag and drop</p> */}
            </div>
            <input disabled id="dropzone-file" type="file" class="hidden" />
          </label>
        </div>
      </div>
      <hr className="mt-2" />
      <div className="justify-items-center text-center">
        <button
          onClick={handleSave}
          className="border px-5 py-3 bg-[#241C68] rounded-lg text-xl text-white w-96 mt-3.5 "
        >
          Save
        </button>
      </div>
     
    </div>
  );
};

export default LandAcquistion;
